import moment from "moment";
import "./SeperationRequestList.css";
import InitialsCircle from "../InitialsCircle";

const SeperationRequestList = ({ data, onSelect }) => {
  const DataCard = ({ item, index }) => {
    return (
      <div
        className="summary-container"
        style={{ cursor: "pointer", marginBottom: 12 }}
        index={index}
        onClick={() => onSelect(item)}
      >
        <div className="summary-header">
          <div className="summary-emp-id">Employee ID #{item.employee_id}</div>

          <div className="emp-logo-box">
            {/* <img className="rq-emp-icon" src={UserIcon} alt="emp-icon" /> */}
            <InitialsCircle fullName={item?.full_name} size={24} />
            <div className="summary-emp-name">{item.full_name}</div>

            <div className="spacer-dot">•</div>

            <div className="summary-loc">Separation</div>
          </div>
        </div>

        <div className="flex flex-direction-row summary-container-row sep-row w-full">
          <div className="summary-row-details">
            <div className="row-item-heading text-left">
              Date of Resignation
            </div>
            <div className="row-item-value text-left">
              {item?.date_of_resignation}
            </div>
          </div>
          <div className="summary-row-details">
            <div className="row-item-heading text-left">
              Days until last working day
            </div>
            <div className="row-item-value text-left">
              {item.final_date_of_exit
                ? Math.max(
                    moment(new Date(item.final_date_of_exit)).diff(
                      new Date(),
                      "days",
                    ),
                    0,
                  )
                : ""}
            </div>
          </div>
          <div className="summary-row-details">
            <div className="row-item-heading text-left">
              Final date Of Exit
            </div>
            <div className="row-item-value text-left">
              {item.final_date_of_exit}
            </div>
          </div>
          <div className="summary-row-details">
            <div className="row-item-heading text-left">Recovery Days</div>
            <div className="row-item-value text-left">
              {item.recovery_days}
            </div>
          </div>
          <div className="summary-row-details">
            <div className="row-item-heading text-left">Separation Reason</div>
            <div className="row-item-value text-left">{item.reason}</div>
          </div>
          <div className="summary-row-details">
            <div className="row-item-heading text-left">Status</div>
            {item.status === "Approved" && (
              <div className="row-item-green">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {(item.status === "Pending" || !item.status) && (
              <div className="row-item-orange">
                <div className="color-label-text">
                  {item.status || "Pending"}
                </div>
              </div>
            )}
            {item.status === "Revoked" && (
              <div className="row-item-red">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
            {item.status === "Rejected" && (
              <div className="row-item-red">
                <div className="color-label-text">{item.status}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="w-full">
      {data?.map((item) => (
        <DataCard item={item} />
      ))}
    </div>
  );
};
export default SeperationRequestList;
